import React, {
	Dispatch,
	useCallback,
	useEffect,
	useMemo,
	useState,
} from "react";
import { useTranslation } from "react-i18next";

import MultiSelectWithModalBase, {
	MultiSelectWithModal,
} from "../MultiSelectWithModal";

enum TransferOptionEnum {
	SENT_TRANSFER = "sentTransfer",
	RECEIVED_TRANSFER = "receivedTransfer",
}
const TRANSFER_OPTIONS_ARRAY = Object.values(TransferOptionEnum);

const MultiSelectTransferWithModal: React.FC<
	MultiSelectTransferWithModal.Props
> = ({
	value,
	onChange,
	disabled,
	titleText,
	required,
	modalSetting,
	error = "",
	sort,
	...props
}) => {
	const { t } = useTranslation();

	const [errorInternal, setErrorInternal] = useState<string | boolean>("");

	useEffect(() => {
		setErrorInternal(error);
	}, [error]);

	const selectOptions = useMemo<MultiSelectWithModalBase.Value>(() => {
		const retval = TRANSFER_OPTIONS_ARRAY.map((item, index) => {
			const label = t(`multiSelectTransferWithModal.${item}`) ?? "";
			return {
				key: item,
				label,
				value: index,
				name: label,
				data: { type: item },
			};
		}) as MultiSelectWithModalBase.Value;
		return retval;
	}, [t]);

	const selected = useMemo<MultiSelectWithModalBase.Value>(
		() =>
			selectOptions.filter((item) => value.includes(item.key as string)),
		[selectOptions, value],
	);

	const selectOnChange = useCallback(
		(newValue: MultiSelectWithModalBase.Value) => {
			setErrorInternal("");
			const ids: string[] = newValue.map((item) => item.key as string);

			onChange(ids);
		},
		[onChange],
	);

	const texts = useMemo(
		() => ({
			title: t(titleText),
			allText: t("all_transfer"),
			allActiveText: t("all_active_transfer"),
		}),
		[t, titleText],
	);

	return (
		<MultiSelectWithModal
			value={selected}
			onChange={selectOnChange}
			options={selectOptions}
			error={errorInternal}
			modalSetting={modalSetting}
			disabled={disabled}
			title={texts.title}
			allText={texts.allText}
			allActiveText={texts.allActiveText}
			required={required}
			pullUpItemInsideArray
			hiddenButton={false}
			showSelectAll
			sort={{
				show: true,
				active: true,
				...(sort || {}),
			}}
			{...props}
		/>
	);
};

declare namespace MultiSelectTransferWithModal {
	interface Props extends MultiSelectWithModalBase.Setting {
		value: Value;
		onChange: Dispatch<Value>;
		titleText: string | string[];
		modalSetting?: MultiSelectWithModalBase.ListSelectProps["modalSetting"];
	}

	type Value = string[];
}

export default MultiSelectTransferWithModal;
